import { EMAIL_TOKENS } from "../../styles/tokens";
import { Section } from "@react-email/components";
interface QuoteAttrs {
  header: string;
  bodyHtml: string;
}
export function quoteEmailRenderer(attrs: QuoteAttrs) {
  return <Section style={{
    paddingTop: EMAIL_TOKENS.spacing.md
  }}>
      <div style={{
      fontSize: EMAIL_TOKENS.fontSize.xs,
      color: EMAIL_TOKENS.colors.text.secondary,
      whiteSpace: "pre-line",
      paddingBottom: EMAIL_TOKENS.spacing.xs
    }}>
        {attrs.header}
      </div>
      {/*
        bodyHtml is already sanitized at the trust boundary where untrusted
        message HTML enters the quote block — see email-reply-composer.tsx and
        email-forward-composer.tsx, which DOMPurify.sanitize() the original
        message before constructing the emailQuote node. This renderer runs
        server-side via /api/email/render, where browser-only DOMPurify has no
        `window` and would throw, so we render the pre-sanitized HTML directly.
       */}
      <blockquote style={{
      margin: "0",
      paddingLeft: EMAIL_TOKENS.spacing.sm,
      borderLeft: `2px solid ${EMAIL_TOKENS.colors.border.default}`
    }} dangerouslySetInnerHTML={{
      __html: attrs.bodyHtml
    }} />
    </Section>;
}